import React from 'react';
export function Warranties() {
  return <section data-id="element-785">
      <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-786">
        Warranties
      </h2>
      <ul className="space-y-2" data-id="element-787">
        <li data-id="element-788">• Manufacturer warranties remain valid on engraved items.</li>
        <li data-id="element-789">
          • Warranties for <strong data-id="element-790">Daedo socks and gloves</strong> cover{' '}
          <strong data-id="element-791">normal wear and tear only</strong>.
        </li>
        <li data-id="element-792">• For warranty claims or questions, contact info@tkdscore.com.</li>
      </ul>
    </section>;
}